interface RateLimiterOptions {
  maxAttempts: number;
  timeWindow: number; // in milliseconds
}

class RateLimiter {
  private attempts: Map<string, { count: number; lastAttempt: number }>;
  private options: RateLimiterOptions;

  constructor(options: RateLimiterOptions) {
    this.attempts = new Map();
    this.options = options;
  }

  public isAllowed(key: string): boolean {
    const now = Date.now();
    const attempt = this.attempts.get(key);

    if (!attempt) {
      this.attempts.set(key, { count: 1, lastAttempt: now });
      return true;
    }

    if (now - attempt.lastAttempt > this.options.timeWindow) {
      this.attempts.set(key, { count: 1, lastAttempt: now });
      return true;
    }

    if (attempt.count >= this.options.maxAttempts) {
      return false;
    }

    this.attempts.set(key, {
      count: attempt.count + 1,
      lastAttempt: now,
    });

    return true;
  }

  public reset(key: string): void {
    this.attempts.delete(key);
  }
}

// Create a singleton instance for token refresh
export const tokenRefreshLimiter = new RateLimiter({
  maxAttempts: 5, // Maximum 5 attempts
  timeWindow: 5 * 60 * 1000, // 5 minutes window
});

export default RateLimiter;
